export class FloorPickerHelper {
  private constructor() {}

  public static readonly FLOOR_OPTIONS: FloorOption[] = [
    { label: 'Gelijkvloers', value: 'Gelijkvloers' },
    { label: 'Tussen 0 - 1', value: 'Tussen 0 - 1' },
    { label: '1ste verdieping', value: '1ste verdieping' },
    { label: 'Tussen 1 - 2', value: 'Tussen 1 - 2' },
    { label: 'Hoger', value: null }
  ];
}

export interface FloorOption {
  label: string;
  value: string | null;
}
